import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ERouterName } from '/@/types/index'

const WaylinePanel = () => import('/@/pages/page-web/projects/wayline.vue')
const CreatePlan = () => import('/@/components/task/CreatePlan.vue')
const DockPanel = () => import('/@/pages/page-web/projects/dock.vue')
const LiveAgora = () => import('/@/components/livestream-agora.vue')
const LiveOthers = () => import('/@/components/livestream-others.vue')
const WorkspaceLayout = () => import('/@/pages/page-web/projects/workspace.vue')

// 静态路由
export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/model-share/:token',
    name: 'ModelShare',
    component: () => import('/@/pages/page-web/projects/stockLibrary/modelShare.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('/@/pages/page-web/404.vue')
  },
  {
    path: '/',
    redirect: '/' + ERouterName.PROJECT
  },
  // 登录
  {
    path: '/' + ERouterName.PROJECT,
    name: ERouterName.PROJECT,
    component: () => import('/@/pages/page-web/index.vue')
  },
  // 免登录
  // {
  //   path: '/' + ERouterName.FREE_LOGIN,
  //   name: ERouterName.FREE_LOGIN,
  //   component: () => import('/@/pages/page-web/freeLogin.vue')
  // },
  // 大屏
  {
    path: '/' + ERouterName.LARGE_SCREEN,
    name: ERouterName.LARGE_SCREEN,
    component: () => import('/@/pages/page-web/largeScreen.vue'),
    meta: {
      keepAlive: true
    }

  },
  {
    path: '/' + ERouterName.NEW_HOME,
    name: ERouterName.NEW_HOME,
    component: () => import('/@/pages/page-web/newHome.vue'),
    children: [
      {
        path: '/' + ERouterName.MANAGE_DEVICE,
        name: ERouterName.MANAGE_DEVICE,
        component: () => import('/@/pages/page-web/system/device/index.vue')
      },
      {
        path: '/' + ERouterName.MANAGE_MENU,
        name: ERouterName.MANAGE_MENU,
        component: () => import('/@/pages/page-web/system/menu/index.vue')
      },
      {
        path: '/' + ERouterName.MANAGE_REGION,
        name: ERouterName.MANAGE_REGION,
        component: () => import('/@/pages/page-web/system/region/index.vue')
      },
      {
        path: '/' + ERouterName.MANAGE_ROLE,
        name: ERouterName.MANAGE_ROLE,
        component: () => import('/@/pages/page-web/system/role/index.vue')
      }
    ]
  },
  // 飞行记录回看
  {
    path: '/' + ERouterName.FLIGHT_REPLAY,
    name: ERouterName.FLIGHT_REPLAY,
    component: () => import('/@/pages/page-web/projects/flightReplay.vue')
  },
  // 临时任务
  {
    path: '/temp_task',
    name: 'temp_task',
    component: () => import('/@/pages/page-web/projects/flightPoint.vue')
  },
  {
    path: '/quick-wayline-planning',
    name: 'QuickWaylinePlanning',
    component: () => import('/@/pages/page-web/projects/quickWayline/index.vue'),
    meta: {
      permission: 'wayline:quick-planning:view'
    }
  },
  {
    path: '/fh2-wayline-editor',
    name: 'Fh2WaylineEditor',
    component: () => import('/@/pages/page-web/fh2-wayline-editor.vue')
  },
  {
    path: '/main_navi',
    name: 'MainNavi',
    component: () => import('/@/test-home/test-home.vue')
  },
  {
    path: '/event-disposal/detail/:id',
    name: 'EventDisposalDetail',
    component: WorkspaceLayout,
    children: [
      {
        path: '',
        name: 'EventDisposalDetailView',
        component: () => import('/@/pages/page-web/projects/incidentDetail.vue')
      }
    ]
  },
  // 大屏-多屏直播（只保留顶部头部）
  {
    path: '/' + ERouterName.VIDEO_T,
    name: ERouterName.VIDEO_T,
    component: () => import('/@/pages/page-web/system/video-t/index.vue')
  },
  {
    path: '/video-t2',
    name: 'video-t2',
    component: () => import('/@/pages/page-web/system/video-new/index.vue')
  },
  // pilot
  {
    path: '/' + ERouterName.PILOT,
    name: ERouterName.PILOT,
    component: () => import('/@/pages/page-pilot/pilot-index.vue'),
  },
  {
    path: '/' + ERouterName.PILOT_HOME,
    component: () => import('/@/pages/page-pilot/pilot-home.vue')
  },
  // 任务规划（计划任务）
  {
    path: '/' + ERouterName.TASK,
    name: ERouterName.TASK,
    component: () => import('/@/pages/page-web/projects/task.vue')
  },
  {
    path: '/' + ERouterName.FIRMWARES,
    component: () => import('/@/pages/page-web/projects/workspace.vue'),
    children: [
      {
        path: '',
        name: ERouterName.FIRMWARES,
        component: () => import('/@/pages/page-web/projects/Firmwares.vue')
      }
    ]
  },
  {
    path: '/waylinePlanB',
    name: 'waylinePlanB',
    component: () => import('/@/pages/page-web/projects/waylinePlan.vue')
  },
  {
    path: '/planar',
    name: 'planar',
    component: () => import('/@/pages/page-web/projects/planarWayline/index.vue')
  },
  {
    path: '/oblique',
    name: 'oblique',
    component: () => import('/@/pages/page-web/projects/obliqueWayline/index.vue')
  },
  {
    path: '/' + ERouterName.PILOT_MEDIA,
    component: () => import('/@/pages/page-pilot/pilot-media.vue')
  },
  {
    path: '/' + ERouterName.PILOT_LIVESHARE,
    component: () => import('/@/pages/page-pilot/pilot-liveshare.vue')
  },
  {
    path: '/' + ERouterName.PILOT_BIND,
    component: () => import('/@/pages/page-pilot/pilot-bind.vue')
  },
  // 新的直播页面
  {
    path: '/' + ERouterName.LIVESTREAM_NEW,
    name: ERouterName.LIVESTREAM_NEW,
    component: () => import('/@/pages/page-web/projects/livestream-new.vue')
  },
  // 图层管理
  {
    path: '/' + ERouterName.LAYER,
    name: ERouterName.LAYER,
    component: () => import('/@/pages/page-web/projects/layer.vue')
  },
  // 媒体文件
  {
    path: '/' + ERouterName.MEDIA,
    name: ERouterName.MEDIA,
    component: () => import('/@/pages/page-web/projects/media.vue')
  },
  // 标注管理
  // {
  //   path: '/' + ERouterName.Annotation_Management,
  //   name: ERouterName.Annotation_Management,
  //   component: () => import('/@/pages/page-web/projects/annotationManagement.vue')
  // },
  // 无人机仪表盘测试页
  {
    path: '/uav-dashboard-test',
    name: 'UavDashboardTest',
    component: () => import('/@/pages/page-web/uav-dashboard-test.vue')
  },
  // Mars3D 时序动画独立测试页，不接平台菜单和共享地图运行时
  {
    path: '/mars3d-timeline-test',
    name: 'Mars3dTimelineTest',
    component: () => import('/@/pages/page-web/presentation-test.vue')
  },
  {
    path: '/liveBroadcast',
    name: 'liveBroadcast',
    component: () => import('/@/pages/page-web/projects/liveBroadcast.vue')
  },
  {
    path: '/live-streaming-task',
    name: 'liveStreamingTask',
    component: () => import('/@/pages/page-web/projects/live-streaming-task.vue')
  },
  {
    path: '/flight-control',
    name: 'flight-control',
    component: () => import('/@/pages/page-web/projects/flight-control.vue')
  },
  {
    path: '/navigator',
    name: 'navigator',
    component: () => import('/@/pages/page-web/navigation-demo.vue')
  },
]

/**
 * 创建路由
 */
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: constantRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

/**
 * 重置路由
 */
export function resetRouter () {
  router.replace({ path: `/${ERouterName.PROJECT}` })
}

export default router
